import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
@Component({
  selector: "header-route-menu-light",
  templateUrl: "./header-route-menu-light.component.html",
  styleUrls: ["./header-route-menu-light.component.css"],
})
export class HeaderRouteMenuLightComponent implements OnInit {
  @Input()
  currentPageName: string;

  @Input()
  moduleName: string;

  @Input()
  related: boolean = true;

  @Input()
  parentPageName: string | null = null;

  @Input()
  prevUrl: string;

  @Input()
  parentUrl: string;

  @Input()
  createRoute: string;

  @Input()
  isPractise: boolean = false;

  @Input()
  isSelectedAll: boolean = false;

  @Output() practiseEmit: any = new EventEmitter<boolean>();
  @Output() selectedAllEmit: any = new EventEmitter<boolean>();

  public setPractise: boolean = false;

  @Input()
  isCheckPractise: boolean;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _loc: Location
  ) {}

  ngOnInit() {
    // this._route.queryParams.subscribe(
    //   (params) => {
    //       this.setPractise = Boolean(params.isPractise);
    //       console.log(this.setPractise)
    //   });
  }

  goPrev() {
    this._loc.back();
  }

  goPrev1() {
    if (this.prevUrl && this.related) {
      this._router.navigate([this.prevUrl], { relativeTo: this._route });
    } else {
      this._router.navigate([this.prevUrl]);
    }
  }

  goParent() {
    this._router.navigate([this.parentUrl]);
  }

  onSetPractise() {
    this.setPractise = !this.setPractise;

    this.practiseEmit.emit(this.setPractise);
  }
  onSetSelectAll() {
    this.selectedAllEmit.emit(true);
  }

  ngOnChanges(changes): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }
}
